import {
  CHEMICAL_FIELDS,
  CHEMICAL_PRICE_RANGE,
  CHEMICAL_UNIT_DROPDOWN_OPTIONS,
} from "../chemicalLibrary.constants";

const LABEL = "label";
const VALUE = "value";
const INPUT_TYPE = "inputType";
const TYPE = "type";
const DISABLED = "disabled";

export const ADD_EDIT_FORM_CONTROLS = (t) => ({
  [CHEMICAL_FIELDS.category]: {
    id: CHEMICAL_FIELDS.category,
    [TYPE]: "input", // change to dropdown for add new chemical
    [LABEL]: t("chemicalLibrary.category"),
    [VALUE]: "",
    [DISABLED]: false,
    // placeholder: t("chemicalLibrary.selectCategory"),
    options: [],
    labelKey: "name",
  },
  [CHEMICAL_FIELDS.chemical]: {
    id: CHEMICAL_FIELDS.chemical,
    [TYPE]: "input", // change to dropdown for add new chemical
    [LABEL]: t("chemicalLibrary.chemical"),
    [VALUE]: "",
    [DISABLED]: true,
    options: [],
    // placeholder: t("chemicalLibrary.selectChemical"),
    labelKey: "name",
  },
  [CHEMICAL_FIELDS.symbol]: {
    id: CHEMICAL_FIELDS.symbol,
    [LABEL]: t("chemicalLibrary.symbol"),
    [INPUT_TYPE]: "text",
    [TYPE]: "input",
    [VALUE]: "",
    [DISABLED]: true,
  },
  [CHEMICAL_FIELDS.chemical]: {
    id: CHEMICAL_FIELDS.chemical,
    [LABEL]: t("chemicalLibrary.chemical"),
    [INPUT_TYPE]: "text",
    [TYPE]: "input",
    [VALUE]: "",
    [DISABLED]: true,
  },

  [CHEMICAL_FIELDS.bulkConcentration]: {
    id: CHEMICAL_FIELDS.bulkConcentration,
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    [LABEL]: t("chemicalLibrary.bulkConcentration"),
    unit: "%",
    [VALUE]: "0",
    [DISABLED]: true,
  },
  [CHEMICAL_FIELDS.bulkDensity]: {
    id: CHEMICAL_FIELDS.bulkDensity,
    [LABEL]: t("chemicalLibrary.bulkDensity"),
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    unit: "g/cm³",
    [VALUE]: "0",
    [DISABLED]: true,
    roundOff: 4,
  },
  [CHEMICAL_FIELDS.price]: {
    id: CHEMICAL_FIELDS.price,
    [LABEL]: t("chemicalLibrary.bulkPrice"),
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    unit: "$",
    [VALUE]: "0",
    [DISABLED]: true,
    roundOff: 3,
    range: {
      min: CHEMICAL_PRICE_RANGE.min,
      max: CHEMICAL_PRICE_RANGE.max,
    },
  },
  [CHEMICAL_FIELDS.unit]: {
    id: CHEMICAL_FIELDS.unit,
    [LABEL]: t("chemicalLibrary.type"),
    [TYPE]: "dropdown",
    [VALUE]: "",
    [DISABLED]: true,
    // placeholder: t("chemicalLibrary.selectUnit"),
    options: CHEMICAL_UNIT_DROPDOWN_OPTIONS,
    labelKey: LABEL,
  },
  [CHEMICAL_FIELDS.displayName]: {
    id: CHEMICAL_FIELDS.displayName,
    [LABEL]: t("chemicalLibrary.displayLabel"),
    [INPUT_TYPE]: "text",
    [TYPE]: "input",
    [VALUE]: "",
    [DISABLED]: true,
  },
});
